export const FETCH_SEAT_MAP = 'marvel/seat-map/FETCH_SEAT_MAP'

export type SeatMapState = Readonly<{
  byId: string | null
  loading: boolean
  lastFetch: string | null
}>
